webpackJsonp([44070600972715],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.porlandImageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeroSmall = __webpack_require__(8);
	
	var _HeroSmall2 = _interopRequireDefault(_HeroSmall);
	
	var _LocationMicroNav = __webpack_require__(10);
	
	var _LocationMicroNav2 = _interopRequireDefault(_LocationMicroNav);
	
	var _LocationContent = __webpack_require__(9);
	
	var _LocationContent2 = _interopRequireDefault(_LocationContent);
	
	var _LocationRelated = __webpack_require__(11);
	
	var _LocationRelated2 = _interopRequireDefault(_LocationRelated);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortlandLocation = function (_React$Component) {
	  _inherits(PortlandLocation, _React$Component);
	
	  function PortlandLocation() {
	    _classCallCheck(this, PortlandLocation);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PortlandLocation.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_HeroSmall2.default, { location: 'Portland, OR' }),
	      _react2.default.createElement(_LocationMicroNav2.default, null),
	      _react2.default.createElement(_LocationContent2.default, {
	        category: 'PlacesForBikes',
	        title: 'Play in the Dirt',
	        story: 'We attended opening day for Gateway Green, the new 25-acre mountain and dirt biking park opened by the City of Portland on previously vacant land. It\'s the first real mountain biking facility within city limits. Thanks to Portland\'s participation in the Big Jump, in two years the park will be accessible via a continuous low-stress biking network that will run through the city\'s most culturally and economically diverse neighborhoods.'
	      }),
	      _react2.default.createElement(_gatsbyImage2.default, {
	        title: 'Portland',
	        alt: 'Gateway Green project image',
	        sizes: this.props.data.portlandImage.sizes
	      }),
	      _react2.default.createElement(_LocationRelated2.default, {
	        prevLocationName: 'Columbus, OH',
	        prevLocationPath: 'columbus',
	        prevLocationImgPath: this.props.data.portlandPrevImage,
	        nextLocationName: 'Texas',
	        nextLocationPath: 'texas',
	        nextLocationImgPath: this.props.data.portlandNextImage
	      })
	    );
	  };
	
	  return PortlandLocation;
	}(_react2.default.Component);
	
	exports.default = PortlandLocation;
	
	// GraphQL query
	
	var porlandImageQuery = exports.porlandImageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portland-js-cb50d7d0de710fac644b.js